import { UPDATE_USER_NAME, UPDATE_DIALOG_SHOW } from './mutation-types';

export default {
  [UPDATE_USER_NAME](state, name) {
    state.name = name
  },
  [UPDATE_DIALOG_SHOW](state, bool) {
    state.exportUsersDialog = bool
  },
  storeUuid( state , val ){
    state.uuid = val;
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/users/mutations.js